define([
    "underscore",
    "backbone",
    "forms/deposit/deposit_common_form"
], function(_, Backbone, DepositCommonForm) {
    return DepositCommonForm.extend({
        url: "/rest_deposit/validate_form/otc365",

        validation: {
            amount: {
                required: true,
                pattern: 'number',
                min: 1
            },
            full_name: {
                required: true
            },
            mobile_number: {
                required: true
            },
            id_number: {
                required: true
            },
            agree: {
                acceptance: true
            }
        },

        labels:{
            full_name: "全名",
            mobile_number: "手机号码",
            id_number: "身份证号码",
            agree: "同意"
        }
    });
});
